
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","fill":"none","stroke":"#6C7684","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"13.998","cy":"14.507","r":"3.491","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('circle',{attrs:{"cx":"23.002","cy":"15.497","r":"2.501","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M7.996 26.002v-1.017A3.984 3.984 0 0111.981 21h4.035a3.984 3.984 0 013.985 3.985v1.017M23.002 21h1.102c2.201 0 3.985 1.784 3.985 3.985v1.017","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    